import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { useStyles } from "./OverallDowntimeSummaryPieLegends.styles";
import { IOverallDowntimeSummaryPieChartLegendsProps } from "./OverallDowntimeSummaryPieLegendsInterfaces";
import { truncateLongText } from "utilities/utilities";

export const OverallDowntimeSummaryPieLegends = ({ data }: IOverallDowntimeSummaryPieChartLegendsProps) => {
    const classes = useStyles();

    const sortedStats = useMemo(() => {
        const stats = [...data];
        return stats.filter((item) => item.value).sort((a, b) => b.value - a.value);
    }, [data]);

    return (
        <Box className={classes.container}>
            {data &&
                sortedStats.map((item) => (
                    <Box className={classes.dataContainer} key={item.id}>
                        <Box className={classes.failureTypeContainer}>
                            <CircleIcon sx={{ color: item.color }} />
                            <Typography variant="error">{truncateLongText(item.name, 18)}</Typography>
                        </Box>
                        <Box className={classes.valueContainer}>
                            <Typography variant="error">
                                <span className={classes.value}>{item.total}</span> {`(${item.value}%)`}
                            </Typography>
                        </Box>
                    </Box>
                ))}
        </Box>
    );
};
